import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 md:px-8 md:py-24" data-id="element-130" data-mp="122dcj896vvca">
      <div className="mx-auto max-w-3xl" data-id="element-131" data-mp="124pp15w6hdhy">
        <h2 className="text-center font-display text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-132" data-mp="1pro4q1ch4het">Frequently Asked Questions</h2>
        <ul className="mt-10 divide-y divide-ice-line border-y border-ice-line" data-id="element-133" data-mp="1uqrajo0a2rnu">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-134" data-mp="1l0fuj33bks0l" data-mpi={i}>
                <button type="button" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-start justify-between gap-4 py-5 text-left" data-id="element-135" data-mp="1kzoampj34iq5">
                  <span className="font-display text-[16px] font-extrabold leading-snug text-ink" data-id="element-136" data-mp="2ora772ug3jyp">{f.q}</span>
                  <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-137" data-mp="2jsgq70fy9ats" />
                </button>
                <AnimatePresence initial={false} data-id="element-138" data-mp="37ggi43ozz79y">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-139" data-mp="37ijk7m3fcqv1">
                      <div className="space-y-3 pb-5 text-[15px] leading-relaxed text-ink-muted" data-id="element-140" data-mp="1n1obo78nzqu4">
                        {f.a.map(p => <p key={p} data-id="element-141" data-mp="27pxln12gj7q8">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <SectionCta label="I’m Ready — Get Access for $27" data-id="element-142" data-mp="2gqcimxosab9k" />
      </div>
    </section>;
}